import type { User } from '@supabase/supabase-js'
import { useEffect, useState } from 'react'
import { supabase } from '@/lib/api/client'

/**
 * Hook to get the currently authenticated user from Supabase session.
 * Listens to Supabase auth state changes for real-time updates.
 */
export function useUser() {
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Initial load - use getUser() to validate token is still valid
    const initAuth = async () => {
      const { data: { user }, error } = await supabase.auth.getUser()
      if (error) {
        console.warn('[useUser] Error getting user:', error.message)
        setUser(null)
      } else {
        setUser(user)
      }
      setIsLoading(false)
    }

    initAuth()

    // Listen to auth state changes (login, logout, token refresh)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
      setIsLoading(false)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  return { user, isLoading }
}
